<template>
  <span>
    <svg
      :width="size"
      :height="size"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      :style="{ color: strokeColor }"
    >
      <path
        d="M19.7855 12.9523L18.7955 5.0323C18.7352 4.55371 18.5022 4.11358 18.1404 3.79458C17.7785 3.47558 17.3127 3.29964 16.8303 3.2998H2.64031C2.29023 3.2998 1.95448 3.43888 1.70693 3.68642C1.45938 3.93397 1.32031 4.26972 1.32031 4.6198V11.8798C1.32031 12.2299 1.45938 12.5656 1.70693 12.8132C1.95448 13.0607 2.29023 13.1998 2.64031 13.1998H6.19276L9.30961 19.4352C9.36448 19.5448 9.44881 19.637 9.55315 19.7014C9.65748 19.7658 9.7777 19.7999 9.90031 19.7998C10.7755 19.7998 11.6149 19.4521 12.2338 18.8333C12.8526 18.2144 13.2003 17.375 13.2003 16.4998V15.1798H17.8203C18.1013 15.1799 18.3791 15.1202 18.6352 15.0047C18.8913 14.8891 19.1199 14.7204 19.3058 14.5097C19.4916 14.299 19.6306 14.0512 19.7133 13.7826C19.796 13.5141 19.8206 13.2311 19.7855 12.9523ZM5.94031 11.8798H2.64031V4.6198H5.94031V11.8798ZM18.3153 13.6362C18.2538 13.707 18.1777 13.7636 18.0923 13.8022C18.0068 13.8408 17.9141 13.8604 17.8203 13.8598H12.5403C12.3653 13.8598 12.1974 13.9293 12.0736 14.0531C11.9498 14.1769 11.8803 14.3448 11.8803 14.5198V16.4998C11.8804 16.9576 11.7219 17.4013 11.4318 17.7553C11.1416 18.1094 10.7378 18.352 10.2889 18.4419L7.26031 12.3839V4.6198H16.8303C16.9911 4.61975 17.1464 4.6784 17.267 4.78473C17.3876 4.89106 17.4653 5.03777 17.4854 5.1973L18.4754 13.1173C18.4877 13.2102 18.4798 13.3047 18.4522 13.3943C18.4246 13.4839 18.3779 13.5664 18.3153 13.6362Z"
        fill="currentColor"
      />
    </svg>
  </span>
</template>

<script>
export default {
  name: 'ThumbsDown',
  props: {
    strokeColor: {
      type: String,
      default: '#E7000B',
    },
    size: {
      type: [Number, String],
      default: 18,
    },
  },
};
</script>
